<script>
import partnerChoices from '@/mixins/partnerChoices';
import YesNoChoice from '../Form/YesNoChoice.vue';
import DateInput from '../Form/DateInput.vue';
import ConditionalGroup from '../Form/ConditionalGroup.vue';
import dayOptions from '@/lib/dayOptions';
import monthOptions from '@/lib/monthOptions';
import {hasEditPermission,currentRoleLevelName,trialActiveForClients} from '@/mixins/roleLevelPermissions';
import { mapState } from 'vuex';
export default {
	components: { YesNoChoice, DateInput, ConditionalGroup },
	mixins: [partnerChoices, dayOptions],
	props: ['agreementData','hideForEdit','itemIndexToShow'],
	data() {
		return { dayOptions, monthOptions,
			isViewMode : !hasEditPermission('section-property'),
			showLearnButton: ['client-level-1', 'client-level-2'].includes(currentRoleLevelName)
		};
	},
	computed: {
		...mapState(['currentRoleLevel']),
		familyResidence() {
			return this.agreementData.familyResidence
			//  = this.agreementData.familyResidence.hasOwnProperty('additionalClausesToRecitals') 
			// 	? this.agreementData.familyResidence 
			// 	: {...this.agreementData.familyResidence, additionalClausesToRecitals: []};
		},
		partnerOwnsChoices() {
			return this.partnerChoices.map((partner) => ({
				...partner,
				text: `${partner.text} owns the property`,
			}));
		},
		clientUserAgreement(){
			return trialActiveForClients() || currentRoleLevelName === 'client-sharing-user';
		},
		isUserSeparatingParty(){
			return this.currentRoleLevel.roleAssociated === 'party'
		},
		dynamicQuestions(){
			if(this.isUserSeparatingParty){
				return {
					responsible: "Which of you is the registered holder of the debt?",
					residenceOption: "What will you and your spouse do with the Family Residence?",
					keep: "Which one of you will keep the family residence?",
					stayingInResidence: "Will the spouse who is selling their interest in the family residence stay until they can find alternative accommodation?",
					responsibleForExpenses: "Will the spouse who is remaining in the Family Residence be solely responsible for the expenses related to the Family Residence?",
					manageExpenses: "How will you manage the expenses related to the Family Residence until it is transferred?",
					upgradesBeforeSale: "Will you make any upgrades to the Family Residence before you list it for sale?",
					upgradesBeforeSale2: "How will you share the cost of the upgrades?",
					responsibleForExpenses2: "Will the one living in the house be solely responsible for the expenses?",
					manageExpenses: "How will you manage the expenses related to the Family Residence until it is sold?",
					coOwnDecision:"We will co-own the Family Residence until one of us buys the other out or we list the property for sale.  We will decide this on:",
					purchaseFamilyResidence:"Would either or you get the first option to purchase the other's interest in the Family Residence?",
					whoWillLiveInResidence:"Who will live in the house until it is transferred or sold at a later date?",
					personLivingInResidenceResponsibleForExpenses:"Will this person be solely responsible for the expenses?",
					whoCanPurchase: "Which of you will be given the first opportunity to exercise the option to purchase?"
				}
			}
			else{
				return {
					responsible: "Which party is responsible for the liability?",
					residenceOption: "What will the parties do with the Family Residence?",
					keep: "Which party will keep the family residence?",
					stayingInResidence: "Will the other party be staying in the family residence while they find alternative accommodation?",
					responsibleForExpenses: "Will the party living in the house be solely responsible for the expenses?",
					manageExpenses: "How will the parties manage the Family Residence expenses until it is transferred or sold?",
					upgradesBeforeSale: "Will the parties make any upgrades to the property before they list it for sale?",
					upgradesBeforeSale2: "How will the parties divide the cost of the upgrades?",
					responsibleForExpenses2: "Will the party living in the house be solely responsible for the expenses?",
					manageExpenses: "How will the parties manage the Family Residence expenses until it is sold?",
					coOwnDecision:"The parties will co-own until they purchase or sell, as decided on:",
					purchaseFamilyResidence:"Would either party like the first option to purchase the other party's interest in the Family Residence?",
					whoWillLiveInResidence:"Who will live in the house until it is sold?",
					personLivingInResidenceResponsibleForExpenses:"Will this party be solely responsible for the expenses?",
					whoCanPurchase: "Which party will be given the first opportunity to exercise the option to purchase?"
				}
			}
		},
		contributeOptions(){
			return[
				{
					text: this.isUserSeparatingParty ? 'The other person will contribute rent' :'Yes, they will contribute rent',
					value: 'contribute-rent',
				},
				{
					text: this.isUserSeparatingParty ?'We will share costs equally' : 'Yes, the parties will share costs equally',
					value: 'equally',
				},
				{
					text: this.isUserSeparatingParty ? 'We will share costs as agreed': 'Yes, the parties will share costs as agreed',
					value: 'as-agreed',
				},
				{
					text: this.isUserSeparatingParty ? 'We will share costs based on an agreed-upon schedule' :  'Yes, the parties will share costs based on an agreed-upon schedule',
					value: 'schedule',
				},
				{
					text:  this.isUserSeparatingParty ? 'The other person will not contribute financially': 'No, they will not contribute financially',
					value: 'no',
				},
			]
		},
		manageOptions(){
			return[
				{
					text: this.isUserSeparatingParty ? 'We will share costs equally' : 'They will share costs equally',
					value: 'equally',
				},
				{
					text: this.isUserSeparatingParty ? 'We will share costs in standard way' : 'They will share costs in standard way',
					value: 'as-agreed',
				},
				{
					text: this.isUserSeparatingParty ? 'We will share costs based on an agreed-upon schedule' : 'They will share costs based on an agreed-upon schedule',
					value: 'schedule',
				},
			]
		}
	},
	methods: {
		newLiability() {
			return {
				exclusions: [],
			};
		},
		normalizeUpgradesBeforeSale() {
			const fr = this.agreementData.familyResidence;
			if (!fr) return;
			if (fr.upgradesBeforeSale === 'equally' || fr.upgradesBeforeSale === 'as-agreed') {
				if (!fr.upgradesCostDivision) {
					this.$set(fr, 'upgradesCostDivision', fr.upgradesBeforeSale);
				}
				fr.upgradesBeforeSale = true;
			}
		},
	},
	created() {
		this.normalizeUpgradesBeforeSale();
	},
	mounted(){
		this.agreementData.familyResidence = this.agreementData.familyResidence.hasOwnProperty('additionalClausesToRecitals') 
			? this.agreementData.familyResidence 
			: {...this.agreementData.familyResidence, additionalClausesToRecitals: []};
		this.normalizeUpgradesBeforeSale();
	}
};
</script>

<template>
	<b-card>
		<div slot="header" class="section-heading">
			<h4>Family Residence</h4>
			<a href="#" onclick="Intercom('showArticle', 11106831)" v-if="this.showLearnButton">Learn &nbsp;<b-icon-book/></a>
		</div>

		<address-input-group v-model="familyResidence.address" class="my-3" :testid="'residence-address'" :disabled="isViewMode"/>

		<b-form-group
			id="input-ownership"
			label="How is the residence owned?"
			label-for="ownership"
		>
			<b-form-select
				id="ownership"
				v-model="familyResidence.owned"
				:options="[
					{ text: 'Jointly', value: 'jointly' },
					...partnerOwnsChoices,
				]"
				data-testid="residence-ownership"
				class="col-lg-8"
				:disabled="isViewMode"
				:class="{ 'custom-disabled': isViewMode }"
			/>
			<b-icon-info-circle class="ml-2 mt-2"
				v-if="isUserSeparatingParty"
				v-b-tooltip.html="'It is important to list this correctly so that the Agreement is correct with Land Titles.'">
			</b-icon-info-circle>
		</b-form-group>

		<input-group
			v-model="familyResidence.value"
			reset-undefined
			class="my-3"
			dollar
			label="What is the value of the family residence?"
			:testid="'residence-value'"
			:disabled="isViewMode"
			:toolTipText="`You should use the Fair Market Value of the Family Residence. The
			assessed value is often not accurate. Under the law, the value should be as of
			the date of the Agreement unless otherwise agreed.`"
		/>
		<template v-if="!clientUserAgreement">
		<b-form-group
			id="input-appraisal"
			label="Was the value determined through an appraisal?"
			label-for="appraisal"
		>
			<b-form-select
				id="appraisal"
				v-model="familyResidence.appraisal"
				:options="[
					{ text: 'Yes', value: true },
					{
						text: isUserSeparatingParty ? 'No, we agreed to the value' :  'No, the parties agreed to the value',
						value: false,
					},
				]"
				data-testid="residence-appraisal"
				class="col-lg-8"
				:disabled="isViewMode"
			/>
			<b-icon-info-circle class="ml-2 mt-2"
				v-if="isUserSeparatingParty"
				v-b-tooltip.html="`It isn't necessary to get an appraisal if you are going to
				sell the Family Residence or co-own it for sometime, but it is wise to get an
				appraisal to determine the Fair Market Value of the residence if either of you
				wishes to 'buyout' the other person.`">
			</b-icon-info-circle>
		</b-form-group>

		<!-- Todo make this conditional work -->
		<conditional-group
			class="my-3"
			:condition="familyResidence.appraisal == true"
		>
			<date-input
				v-model="familyResidence.appraisalDate"
				label="Date of Appraisal"
				class="mb-3"
				:testid="'residence-appraisal-date'"
				:disabled="isViewMode"
			/>
		</conditional-group>
		</template>
		<p class="mt-3">
			Are there any liabilities registered on title to the family
			residence? If so, add details of each individual liability below:
		</p>
		<list-item
			v-slot="{ item: liability, index: index }"
			v-model="familyResidence.liabilities"
			:object-prototype="newLiability"
			new-label="Add Liability"
			:testid="'family-residence-'"
			:disabled="isViewMode"
		>
			<input-group
				v-model="liability.lender"
				input-cols="8"
				label="Name of Financial Institution or Lender"
				class="mb-3"
				:testid="'residence-institution-name-'+index"
				:disabled="isViewMode"
				
			/>

			<b-form-group
				id="input-registered"
				label="Liability registered on the property"
				:label-for="'registered-'+ index"
			>
				<b-form-select
					:id="'registered-'+ index"
					v-model="liability.registered"
					size="sm"
					:options="[
						{ text: 'Mortgage', value: 'Mortgage' },
						{ text: 'Line of Credit', value: 'Line of Credit' }, // value fix
						{ text: 'Other', value: 'other' },
					]"
					:data-testid="'residence-registered-'+index"
					:disabled="isViewMode"
					:class="{ 'custom-disabled': isViewMode }"
					class="col-lg-8"
				/>
				<b-icon-info-circle class="ml-2 mt-2"
					v-if="isUserSeparatingParty"
					v-b-tooltip.html="`Usually, you will have a mortgage or line of credit
					registered on the property. You can choose 'other' if there are family loans,
					liens, or other debts to pay upon transfer or sale.`">
				</b-icon-info-circle>
			</b-form-group>

			<conditional-group
				class="my-3"
				:condition="liability.registered === 'other'"
			>
				<input-group
					v-model="liability.type"
					class="my-3"
					reset-undefined
					input-cols="8"
					label="Type of liability"
					:testid="'residence-type-'+index"
					:disabled="isViewMode"
				/>
			</conditional-group>

			<input-group
				v-model="liability.lastFourDigits"
				class="my-3"
				reset-undefined
				input-cols="4"
				label="Last four digits of the account"
				placeholder="Digits (Optional)"
				:testid="'residence-last-four-digits-'+index"
				:disabled="isViewMode"
			/>

			<b-form-group
				id="input-responsible"
				:label="dynamicQuestions.responsible"
				:label-for="'responsible-'+ index"
			>
				<b-form-select
					:id="'responsible-'+ index"
					v-model="liability.responsible"
					size="sm"
					:options="[
						{
							text: isUserSeparatingParty ? 'We are jointly responsible' :  'Parties are jointly responsible',
							value: 'jointly',
						},
						...partnerChoices,
					]"
					:data-testid="'residence-responsible-'+index"
					:disabled="isViewMode"
					:class="{ 'custom-disabled': isViewMode }"
					class="col-lg-8"
				/>
				<b-icon-info-circle class="ml-2 mt-2"
					v-if="isUserSeparatingParty"
					v-b-tooltip.html="`It's important to identify the person to whom the debt is registered, even though under the law it is a family debt.`">
				</b-icon-info-circle>
			</b-form-group>

			<input-group
				v-model="liability.balance"
				reset-undefined
				class="my-3"
				dollar
				label="What is the amount owing?"
				:testid="'residence-owing-amount-'+index"
				:disabled="isViewMode"
				:toolTipText="'What is the current balance of the debt?'"
			/>
		</list-item>
		<template v-if="!clientUserAgreement">
		<yes-no-choice
			v-if="!clientUserAgreement"
			v-model="familyResidence.hasExclusions"
			label="Are there any exclusions related to the Family Residence?"
			reset-undefined
			class="my-3"
			:testid="'residence-has-exclusions'"
			:disabled="isViewMode"
			:toolTipText="`An exclusion under the law is a portion of the equity that should
			be retained by the person rather than shared. Legal exclusions include parts
			that were obtained through inheritance, gift, or property that was owned before
			you and your spouse began living together. The amount claimed should be the
			original amount received or existing when you started to live together. All
			growth in the Family Residence will be shared under the law. Learn more in the
			Knowledge Base in this section. There is an option to agree to
			exclude a portion of the property.`"
		/>

		<conditional-group
			class="my-3"
			:condition="familyResidence.hasExclusions"
		>
			<exclusion-table
				v-model="familyResidence.exclusions"
				:default-amount="familyResidence.value"
				:default-owner="familyResidence.owned"
				:agreement-data="agreementData"
				:testid="'residence-exclusion-'"
				:disabled="isViewMode"
			/>
		</conditional-group>

		<b-form-group
			v-if="!clientUserAgreement"
			id="input-residenceOption"
			:label="dynamicQuestions.residenceOption"
			label-for="residenceOption"
		>
			<b-form-select
				id="residenceOption"
				v-model="familyResidence.residenceOption"
				size="sm"
				:options="[
					{
						text: isUserSeparatingParty ? 'One of us will keep the residence and buy the other out' : 'One party will keep the residence',
						value: 'keep',
					},
					{
						text: isUserSeparatingParty ? 'We will sell the Family Residence and split the proceeds' : 'The parties will sell the residence and split the proceeds',
						value: 'split',
					},
					{
						text: isUserSeparatingParty ? 'We will co-own the Family Residence for a period of time' : 'The parties will continue to co-own the residence for a period of time',
						value: 'co-own',
					},
				]"
				data-testid="residence-parties-option"
				class="col-lg-8"
				:disabled="isViewMode"
			/>
			<b-icon-info-circle class="ml-2 mt-2"
				v-if="isUserSeparatingParty"
				v-b-tooltip.html="`This should be a practical choice. Does one of you want to
				live in the Family Residence? Will you sell it? Co-own for some time because you
				can't afford to immediately buy the other out? There are a few different
				possibilities, and Divii will calculate the overall payouts accordingly, so you
				do not necessarily have to liquidate.`">
			</b-icon-info-circle>
		</b-form-group>

		<conditional-group
			class="my-3"
			:condition="familyResidence.residenceOption === 'keep'"
		>
			<b-form-group
				id="input-keep"
				:label="dynamicQuestions.keep"
				label-for="keep"
			>
				<b-form-select
					id="keep"
					v-model="familyResidence.keep"
					size="sm"
					reset-undefined
					:options="[...partnerChoices]"
					data-testid='residence-keep'
					class="col-lg-8"
					:disabled="isViewMode"
					:class="{ 'custom-disabled': isViewMode }"
				/>
				<b-icon-info-circle class="ml-2 mt-2"
					v-if="isUserSeparatingParty"
					v-b-tooltip.html="`Practically, which one will buy the other's interest out and take over the mortgage?`">
				</b-icon-info-circle>
			</b-form-group>

			<yes-no-choice
				v-model="familyResidence.stayingInResidence"
				reset-undefined
				:label="dynamicQuestions.stayingInResidence"
				class="my-3"
				:testid="'residence-staying-in-residence'"
				:disabled="isViewMode"
				:toolTipText="`Sometimes it's necessary to cohabit for a little longer while
				things settle. In this case, you want to be mindful of how you'll share costs.
				You have a few general options on how to handle sharing expenses, or you can use
				our Expense Schedule to define the details.`"
			/>

			<conditional-group
				class="my-3"
				:condition="familyResidence.stayingInResidence"
			>
				<b-form-group
					id="input-contribute"
					label="During this time, will they contribute financially?"
					label-for="contribute"
				>
					<b-form-select
						id="contribute"
						v-model="familyResidence.contribute"
						size="sm"
						reset-undefined
						:options="contributeOptions"
						:data-testid="'residence-financial-contribution-'"
						:disabled="isViewMode"
						:class="{ 'custom-disabled': isViewMode }"
					/>
				</b-form-group>

				<conditional-group
					class="my-3"
					:condition="
						familyResidence.contribute === 'contribute-rent'
					"
				>
					<input-group
						v-model="familyResidence.rentAmount"
						reset-undefined
						class="my-3"
						dollar
						label="Rent Amount"
						:testid="'residence-rent-amount-'"
						:disabled="isViewMode"
					/>

					<b-form-group
						id="input-rentCollection"
						label="When does Rent collection start?"
						label-for="rentCollectionStart"
					>
						<b-form-select
							id="rentCollectionStart"
							v-model="familyResidence.rentCollectionStart"
							size="sm"
							reset-undefined
							:options="[
								{
									text: 'On the first day of the month immediately following this Agreement being signed',
									value: 'firstDayAfterSigned',
								},
								{
									text: 'On the first day of the month immediately following the transfer of the Family Residence',
									value: 'firstDayAfterTransfer',
								},
								{
									text: 'On a particular date',
									value: 'date',
								},
							]"
							:data-testid="'residence-rent-collection-start'"
							:disabled="isViewMode"
							:class="{ 'custom-disabled': isViewMode }"
						/>
					</b-form-group>

					<conditional-group
						class="my-3"
						:condition="
							familyResidence.rentCollectionStart === 'date'
						"
					>
						<b-row>
							<b-col cols="4">
								<radio-group
									v-model="
										familyResidence.rentCollectionStartMonth
									"
									select
									label="Month"
									:options="monthOptions"
									:testid="'residence-rent-collection-start-month'"
									:length="'long'"
									:disabled="isViewMode"
								/>
							</b-col>
							<b-col cols="3">
								<radio-group
									v-model="
										familyResidence.rentCollectionStartDay
									"
									select
									label="Day"
									:options="dayOptions"
									:testid="'residence-rent-collection-start-day'"
									:disabled="isViewMode"
								/>
							</b-col>
						</b-row>
					</conditional-group>
					<check-group
						v-model="familyResidence.rentIncludes"
						other
						label="What does Rent include?"
						class="mt-3"
						:options="[
							'room and board',
							'utilities',
							'telephone',
							'cable',
							'internet',
							'groceries',
						]"
						:testid="'residence-rent-includes'"
						:id="'residence-rent-includes'"
						:disabled="isViewMode"
					/>

					<!-- <conditional-group
						class="my-3"
						:condition="
							familyResidence.rentIncludes &&
							familyResidence.rentIncludes.includes('other')
						"
					>
						<input-group
							input-cols="8"
							label="Add another item"
							class="mb-3"
							v-model="familyResidence.rentIncludesOther"
						/>
					</conditional-group> -->
				</conditional-group>
			</conditional-group>

			<conditional-group
				class="my-3"
				:condition="familyResidence.stayingInResidence === false"
			>
				<yes-no-choice
					v-model="familyResidence.responsibleForExpenses"
					reset-undefined
					:label="dynamicQuestions.responsibleForExpenses"
					class="my-3"
					:testid="'residence-expenses-responsibility'"
					:disabled="isViewMode"
					:toolTipText="`Sometimes it's necessary to share expenses until the Family
					Residence is transferred and support commences. In this case, you want to be
					mindful of how you'll share costs. You have a few general options on how to
					handle sharing expenses, or you can use our Expense Schedule to define the
					details.`"
				/>
				<conditional-group
					class="my-3"
					:condition="
						familyResidence.responsibleForExpenses === false
					"
				>
					<b-form-group
						id="input-manageExpenses"
						:label="dynamicQuestions.manageExpenses"
						label-for="manageExpenses"
					>
						<b-form-select
							id="manageExpenses"
							v-model="familyResidence.manageExpenses"
							size="sm"
							reset-undefined
							:options="manageOptions"
							data-testid='residence-expense-management'
							:disabled="isViewMode"
							:class="{ 'custom-disabled': isViewMode }"
						/>
					</b-form-group>
				</conditional-group>
			</conditional-group>
		</conditional-group>

		<conditional-group
			class="my-3"
			:condition="familyResidence.residenceOption === 'split'"
		>
			<b-form-group
				id="input-propertyState"
				label="What is the current state of the property?"
				label-for="propertyState"
			>
				<b-form-select
					id="propertyState"
					v-model="familyResidence.propertyState"
					size="sm"
					:options="[
						{
							text: 'To be listed for sale',
							value: 'to-be-listed',
						},
						{
							text: 'Listed for sale',
							value: 'listed',
						},
						{
							text: 'Contract for purchase and sale has been executed',
							value: 'contract-executed',
						},
					]"
					data-testid='residence-current-state'
					class="col-lg-8"
					:disabled="isViewMode"
					:class="{ 'custom-disabled': isViewMode }"
				/>
			</b-form-group>

			<conditional-group
				class="my-3"
				:condition="familyResidence.propertyState === 'to-be-listed'"
			>
				<yes-no-choice
					v-model="familyResidence.upgradesBeforeSale"
					reset-undefined
					class="my-3"
					:label="dynamicQuestions.upgradesBeforeSale"
					:testid="'residence-upgrades-before-sale'"
					:disabled="isViewMode"
					:toolTipText="`If you and your spouse need to make any repairs or upgrades to
					the Family Residence before it sells, you may specify how you'll share the cost
					of those expenses.`"
				/>

				<conditional-group
					class="my-3"
					:condition="familyResidence.upgradesBeforeSale === true"
				>
					<b-form-group
						id="input-upgradesBeforeSale"
						:label="dynamicQuestions.upgradesBeforeSale2"
						label-for="upgradesBeforeSale"
					>
						<b-form-select
							id="upgradesBeforeSale"
							v-model="familyResidence.upgradesCostDivision"
							size="sm"
							:options="[
								{
									text: isUserSeparatingParty ? 'We will share costs equally' : 'They will share costs equally',
									value: 'equally',
								},
								{
									text: isUserSeparatingParty ? 'We will share costs as agreed' : 'They will share costs as agreed',
									value: 'as-agreed',
								}
							]"
							data-testid='residence-upgrades-cost-division'
							class="col-lg-8"
							:disabled="isViewMode"
							:class="{ 'custom-disabled': isViewMode }"
						/>
						<b-icon-info-circle class="ml-2 mt-2"
							v-if="isUserSeparatingParty"
							v-b-tooltip.html="`Many people will share these costs equally given the shared ownership of the property.`">
						</b-icon-info-circle>
					</b-form-group>
				</conditional-group>
			</conditional-group>

			<conditional-group
				class="my-3"
				:condition="familyResidence.propertyState === 'listed'"
			>
				<input-group
					v-model="familyResidence.realEstateAgent"
					input-cols="8"
					label="Name of real estate agent"
					class="mb-3"
					:testid="'residence-real-estate-agent-name'"
					:disabled="isViewMode"
				/>

				<input-group
					v-model="familyResidence.listingPrice"
					label="Listing Price"
					class="mb-3"
					dollar
					:testid="'residence-listing-price'"
					:disabled="isViewMode"
				/>
			</conditional-group>

			<conditional-group
				class="my-3"
				:condition="
					familyResidence.propertyState === 'contract-executed'
				"
			>
				<input-group
					v-model="familyResidence.salePrice"
					label="What was the sale price of the family residence?"
					class="mb-3"
					dollar
					:testid="'residence-sale-price'"
					:disabled="isViewMode"
				/>

				<date-input
					v-model="familyResidence.saleClosingDate"
					label="What is the closing date of the sale?"
					class="mb-3"
					:testid="'residence-sale-closing-date'"
					:disabled="isViewMode"
				/>
			</conditional-group>

			<b-form-group
				id="input-liveInUntilSold"
				label="Who will live in the house until it is sold?"
				label-for="liveInUntilSold"
			>
				<b-form-select
					id="liveInUntilSold"
					v-model="familyResidence.liveInUntilSold"
					size="sm"
					:options="[
						...partnerChoices,
						{ text: 'Both', value: 'both' },
					]"
					data-testid='residence-live-in-until-sold'
					class="col-lg-8"
					:disabled="isViewMode"
					:class="{ 'custom-disabled': isViewMode }"
				/>
			</b-form-group>

			<conditional-group
				class="my-3"
				:condition="familyResidence.liveInUntilSold === 'both'"
			>
				<b-form-group
					id="input-manageExpenses"
					:label="dynamicQuestions.manageExpenses"
					label-for="manageExpenses"
				>
					<b-form-select
						id="manageExpenses"
						v-model="familyResidence.manageExpenses"
						size="sm"
						:options="[
							{
								text: isUserSeparatingParty ? 'We will share costs equally' : 'They will share costs equally',
								value: 'equally',
							},
							{
								text: isUserSeparatingParty ? 'We will share costs as agreed' : 'They will share costs as agreed',
								value: 'as-agreed',
							}
						]"
						data-testid='residence-expense-management-until-sold'
						class="col-lg-8"
						:disabled="isViewMode"
						:class="{ 'custom-disabled': isViewMode }"
					/>
				</b-form-group>
			</conditional-group>

			<conditional-group
				class="my-3"
				:condition="familyResidence.liveInUntilSold !== 'both'"
			>
				<yes-no-choice
					v-model="familyResidence.responsibleForExpenses"
					reset-undefined
					class="my-3"
					:label="dynamicQuestions.responsibleForExpenses2"
					:testid="'residence-expense-responsibility'"
					:disabled="isViewMode"
					:toolTipText="`Sometimes it's necessary to share expenses until the Family
					Residence is transferred and support commences. In this case, you want to be
					mindful of how you'll share costs. You have a few general options on how to
					handle sharing expenses, or you can use our Expense Schedule to define the
					details.`"
				/>
				<conditional-group
					class="my-3"
					:condition="
						familyResidence.responsibleForExpenses === false
					"
				>
					<b-form-group
						id="input-manageExpenses"
						:label="dynamicQuestions.manageExpenses"
						label-for="manageExpenses"
					>
						<b-form-select
							id="manageExpenses"
							v-model="familyResidence.manageExpenses"
							size="sm"
							:options="manageOptions"
							data-testid='residence-parties-expense-management-until-sold'
							class="col-lg-8"
							:disabled="isViewMode"
							:class="{ 'custom-disabled': isViewMode }"
						/>
					</b-form-group>
				</conditional-group>
			</conditional-group>
		</conditional-group>

		<conditional-group
			class="my-3"
			:condition="familyResidence.residenceOption === 'co-own'"
		>
			<b-form-group
				id="input-coOwnDecision"
				:label="dynamicQuestions.coOwnDecision"
				label-for="coOwnDecision"
			>
				<b-form-select
					id="coOwnDecision"
					v-model="familyResidence.coOwnDecision"
					size="sm"
					:options="[
						{ text: 'A specific date', value: 'specific-date' },
						{
							text: isUserSeparatingParty ? 'On a date as agreed upon between us' :  'On a date as agreed upon between the parties',
							value: 'arranged-date',
						},
					]"
					data-testid='residence-co-own-decision'
					class="col-lg-8"
					:disabled="isViewMode"
				/> 
				<b-icon-info-circle class="ml-2 mt-2"
					v-if="isUserSeparatingParty"
					v-b-tooltip.html="`When you co-own the Family Residence, you both will have
					equity tied up. You each need to make provision for when this arrangement will
					end so that you can each access these funds for your own purposes. By selecting
					a date now, you are specifying when you will end the co-ownership period.
					However you may agree on a date agreed upon by you in the future. You may also
					change the wording in the Editor to allow for a date determined by either party,
					which allows either party to notify of the intention to trigger a transfer or
					sale.`">
				</b-icon-info-circle>
			</b-form-group>

			<conditional-group
				class="my-3"
				:condition="familyResidence.coOwnDecision === 'specific-date'"
			>
				<date-input
					v-model="familyResidence.coOwnDecisionDate"
					label="Specified Date"
					class="mb-3"
					:testid="'residence-co-own-decision-date'"
					:disabled="isViewMode"
				/>
			</conditional-group>

			<yes-no-choice
				v-model="familyResidence.purchaseFamilyResidence"
				:label="dynamicQuestions.purchaseFamilyResidence"
				reset-undefined
				class="my-3"
				:testid="'residence-other-party-purchase'"
				:disabled="isViewMode"
				:toolTipText="`You may give one person the first right to make an offer to buy
				the other's interest in the property - particularly if one person will be
				residing in the Family Residence.`"
			/>

			<conditional-group
				class="my-3"
				:condition="familyResidence.purchaseFamilyResidence"
			>
				<b-form-group
					id="input-whoCanPurchase"
					:label="dynamicQuestions.whoCanPurchase"
					label-for="whoCanPurchase"
				>
					<b-form-select
						id="whoCanPurchase"
						v-model="familyResidence.whoCanPurchase"
						size="sm"
						:options="[...partnerChoices]"
						reset-undefined
						data-testid='residence-who-can-purchase'
						class="col-lg-8"
						:disabled="isViewMode"
						:class="{ 'custom-disabled': isViewMode }"
					/>
				</b-form-group>
			</conditional-group>

			<b-form-group
				id="input-whoWillLiveInResidence"
				:label="dynamicQuestions.whoWillLiveInResidence"
				label-for="whoWillLiveInResidence"
			>
				<b-form-select
					id="whoWillLiveInResidence"
					v-model="familyResidence.whoWillLiveInResidence"
					size="sm"
					:options="[
						...partnerChoices,
						{ text: 'Both', value: 'both' },
					]"
					data-testid='residence-who-will-live-in'
					class="col-lg-8"
					:disabled="isViewMode"
					:class="{ 'custom-disabled': isViewMode }"
				/>
			</b-form-group>

			<conditional-group
				class="my-3"
				:condition="familyResidence.whoWillLiveInResidence !== 'both'"
			>
				<yes-no-choice
					v-model="
						familyResidence.personLivingInResidenceResponsibleForExpenses
					"
					:label="dynamicQuestions.personLivingInResidenceResponsibleForExpenses"
					reset-undefined
					class="my-3"
					:testid="'residence-expense-responsibility'"
					:disabled="isViewMode"
					:toolTipText="`Sometimes it's necessary to share expenses until the Family
					Residence is transferred and support commences. In this case, you want to be
					mindful of how you'll share costs. You have a few general options on how to
					handle sharing expenses, or you can use our Expense Schedule to define the
					details.`"
				/>

				<conditional-group
					class="my-3"
					:condition="
						!familyResidence.personLivingInResidenceResponsibleForExpenses
					"
				>
					<b-form-group
						id="input-manageExpenses"
						:label="dynamicQuestions.manageExpenses"
						label-for="manageExpenses"
					>
						<b-form-select
							id="manageExpenses"
							v-model="familyResidence.manageExpenses"
							size="sm"
							:options="manageOptions"
							data-testid='residence-expense-management-until-sold'
							class="col-lg-8"
							:disabled="isViewMode"
							:class="{ 'custom-disabled': isViewMode }"
						/>
					</b-form-group>
				</conditional-group>
			</conditional-group>

			<conditional-group
				class="my-3"
				:condition="familyResidence.whoWillLiveInResidence === 'both'"
			>
				<b-form-group
					id="input-managecolivingExpenses"
					:label="dynamicQuestions.manageExpenses"
					label-for="managecolivingExpenses"
				>
					<b-form-select
						id="managecolivingExpenses"
						v-model="familyResidence.managecolivingExpenses"
						size="sm"
						:options="manageOptions"
						data-testid='residence-manage-co-living-expenses'
						class="col-lg-8"
						:disabled="isViewMode"
					/> 
					<b-icon-info-circle class="ml-2 mt-2"
						v-if="isUserSeparatingParty"
						v-b-tooltip.html="`Sometimes it's necessary to share expenses until the Family
						Residence is transferred or sold. In this case, you want to be mindful of how
						you'll share costs. You have a few general options on how to handle sharing
						expenses, or you can use our Expense Schedule to define the details.`">
					</b-icon-info-circle>
				</b-form-group>
			</conditional-group>
		</conditional-group>
		</template>
		<template v-if="!clientUserAgreement">
			<additional-clauses :title="'Additional Clauses into Recitals'" :newLabel="'Add Clause to Recitals'" class="mt-2" v-model="familyResidence.additionalClausesToRecitals" :testid="'residence-add-clause-to-recitals-'"
			:disabled="isViewMode"/>
			<additional-clauses :title="'Additional Clauses into Sections'" :newLabel="'Add Clause to Section'" class="mt-2" v-model="familyResidence.additionalClauses" :testid="'residence-add-clause-'"
			:disabled="isViewMode"/>
		</template>
		</b-card>
</template>
